import { TraitCode } from '@capital-markets-gateway/api-client-identity';
import { useMemo } from 'react';

import { useFeatureToggles } from '../../../common/config/context/useFeatureToggles';

const TraitsToToggle = {
  [TraitCode.CERTIFICATE_REVIEW]: 'isCertificateReviewOn',
};

const shouldShowTraitFn =
  (featureToggles: ReturnType<typeof useFeatureToggles>) => (trait: TraitCode | string) => {
    const featureToggleKey = TraitsToToggle[trait];

    if (!featureToggleKey) {
      return true;
    }

    return featureToggles[featureToggleKey];
  };

// #TODO: Remove this hook once the rollout plan ECM-36280 is completed
const useCertificatesAccess = () => {
  const fetureToggles = useFeatureToggles();
  const shouldShowTrait = useMemo(() => shouldShowTraitFn(fetureToggles), [fetureToggles]);

  return { shouldShowTrait };
};

export default useCertificatesAccess;
